import config from "config";
import Cookies from "js-cookie";

/**
 *
 * @param {Obj} access access token obj{token, token_expires}
 * @param {obj} refresh same obj as access
 */
async function setTokens(access, refresh) {
  //-->Set access token
  Cookies.set(config.TOKEN, JSON.stringify(access.token), {
    expires: 1,
    secure: process.env.NODE_ENV !== "development"
  });
  //-->Set refresh token
  Cookies.set(config.REFRESH_TOKEN, JSON.stringify(refresh?.token), {
    expires: 5,
    secure: process.env.NODE_ENV !== "development"
  });
}

function getValueFromCookie(value) {
  let result = null;
  const cookieResponse = Cookies.get(value);

  // to be configured when cookie is set

  if (cookieResponse) {
    result = cookieResponse;
    // result = JSON.parse(result);

    return result;
  }

  return result;
}
/**
 *
 * @returns Access token
 */
function getToken() {
  return getValueFromCookie(config.AUTH_TOKEN);
}
/**
 *
 * @returns Refresh Token
 */
function getRefreshToken() {
  return getValueFromCookie(config.REFRESH_TOKEN);
}

export { setTokens, getToken, getRefreshToken };
